import { MapIcon } from "@heroicons/react/20/solid";
import { ChecboxItem } from "./CheckboxItem";
import { ListToolButton } from "./ListToolButton";
import { Select } from "./Select";
import type { MapState } from "src/types/MapState";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useTranslation } from "src/translations";

const STYLE_LABEL_KEYS: Record<string, string> = {
  light: "mapView.light",
  streets: "mapView.street",
  satellite: "mapView.satellite",
};

export const MapViewButton = observer(function MapViewButton({ mapState }: { mapState: MapState }) {
  const { t } = useTranslation();
  const translatedStyles = useMemo(
    () =>
      mapState.viewStyle.options.map((option) => ({
        ...option,
        label: STYLE_LABEL_KEYS[option.id] ? t(STYLE_LABEL_KEYS[option.id]) : option.label,
      })) as typeof mapState.viewStyle.options,
    [mapState.viewStyle.options, t]
  );
  return (
    <ListToolButton Icon={MapIcon}>
      <div className="space-y-4 pt-2">
        <div className="flex flex-1 justify-center items-center space-x-2 text-gray-200">
          <MapIcon className="w-4 h-4" />
          <span className="font-semibold">{t("mapView.title")}</span>
        </div>
        <Select
          items={translatedStyles}
          onChange={mapState.viewStyle.update}
          selected={mapState.viewStyle.value.id}
        />
        <ul className="space-y-1">
          <ChecboxItem
            label={t("mapView.siteContext")}
            selected={mapState.layerSiteContext.isOn}
            onClick={mapState.layerSiteContext.toggle}
          />
          <ChecboxItem
            label={t("mapView.topography")}
            selected={mapState.layerTopographyLines.isOn}
            onClick={mapState.layerTopographyLines.toggle}
          />
          {/* disabled until https://app.clickup.com/t/86933zwq3 */}
          {/* <ChecboxItem
            label="Site boundary"
            selected={mapState.layerSiteBoundary.isOn}
            onClick={mapState.layerSiteBoundary.toggle}
          /> */}
          <ChecboxItem
            label={t("mapView.zones")}
            selected={mapState.layerZones.isOn}
            onClick={mapState.layerZones.toggle}
          />
        </ul>
      </div>
    </ListToolButton>
  );
});
